export enum BoardTypeEnum {
  TEAM,
  PERSONAL,
}
